export const PURCHASED_ITEMS = 'PurchasedItems'
export const STATUS_CART = 'StatusCart'
export const CUSTOMER_DATA = 'CustomerData'
export const SEND_EVENT = 'sendEvent'
